<template>
<Fragment>
    <template v-if="Object.entries(reviews).length">
        <LoadingApp
            :isLoading.sync="isLoading" 
            :is_full_page="true"
        /> 
        <div>
            <c-heading-2 
                class="text-uppercase heading-text-color font-weight-semibold" 
                id="review-link"
                style="margin-top:1.8rem;" 
            >
                Avaliações
            </c-heading-2>
            <article  
                v-for="(review, key) in reviews" 
                :key="key" 
                class="entry"
            >
                <div class="entry-body" style="margin-left: unset;">
                    <div class="entry-meta">
                        <span>
                            <Rating :item="review"/>
                        </span>
                        <c-span><i class="icon-user"></i>{{getClientName(review.client)}}</c-span>
                        <c-span><i class="icon-calendar"></i>{{review.tempo}}</c-span>
                    </div><!-- End .entry-meta -->

                    <h3 class="entry-title">
                        <c-span class="font-weight-bold">{{review.title}}</c-span>
                    </h3>

                    <div class="entry-content">
                        <c-paragraph>{{review.comment}}</c-paragraph>
                    </div>
                </div>
            </article>
        </div>
        <div 
            style="
                display:flex;
                width: 100%;
                justify-content: center;
            "
        >
            <c-button 
                v-if="showLoadMore"
                :backgroundColor="$root.$children[0].theme.products.button.background_color"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                :textTransform="$root.$children[0].theme.products.button.text_transform"
                :fontSize="$root.$children[0].theme.font_size_button"
                margin="0px 0rem 0px 5px"
                height="3.8rem"
                minWidth="unset"
                padding="1rem 2rem"
                display="flex"
                textAlign="center"
                lineHeight="1.5"
                letterSpacing="unset"
                transition="all .3s"
                justifyContent="center"
                @click.prevent="loadMoreComments()"
                aria-label="Vizualizar mais avaliações"
            >
                <span>Vizualizar mais</span>
            </c-button>
        </div>
    </template>
</Fragment>
</template>

<script>
import {mapActions} from 'vuex'
import Rating from './Rating.vue'
import {Fragment} from 'vue-fragment'
import { CButton } from '../Styles/Button/styled'
import LoadingApp from '../LoadingApp.vue'
import { CHeading2, CLink, CParagraph, CSpan } from '../Styles/Components/styled'

export default {
    name: 'ListReviews',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    components: {
        Rating,
        Fragment,
        LoadingApp,
        'c-button': CButton,
        'c-heading-2': CHeading2,
        'c-paragraph': CParagraph,
        'c-link': CLink,
        'c-span': CSpan
    },
    data() {
        return {
            pagination: {},
            reviews: [],
            page: 1,
            isLoading: false,
            showLoadMore: true
        }
    },
    created() {
        this.getList()
    },
    methods: {
        ...mapActions("rate", [
            "getListByProductId"
        ]),
        async getList() {
            try {
                const page = this.pagination.current_page+1;
                if(!this.validatePagination(page)) return
                const filters = this.getFilters(page)
                if(!filters) return
                const response = await this.getListByProductId({
                    payload: filters,
                    id: this.item.id
                })
                this.pagination = response
                response?.data.length && (this.reviews.push(...response.data))
                this.validatePagination(response.current_page+1)
            } catch(error) {
                alert(error?.msg ?? error)
            }
        },
        validatePagination(page) {
            if(this.pagination.total == 1) {
                this.showLoadMore = false
            }
            if(page == 0 || page == this.pagination.last_page+1) {
                this.showLoadMore = false
                return false;
            }
            return true
        },
        getClientName(client) {
            if(client.user_type == 'J') {
                return client.user_fantasy_name ?? client.user_company_name
            }
            return client.user_company_name
        },
        getFilters(page = 1) {
            
            return {
                page: page
            }
        },
        async loadMoreComments() {
            this.isLoading =  true
            await this.getList()
            this.isLoading =  false
        }
    }
}
</script>

